export default class DtoUserHabilitation {
    constructor(obj) {
        this.login = obj.login
        this.habilitation = obj.habilitation
    }
}